<template>
  <div class="space-y-3">
    <div class="text-sm text-muted">
      {{ __("This project was funded by the Government of Quebec", 'egalite') }}
    </div>
    <SvgLogoQuebec class="h-12 w-auto grayscale" />
  </div>
</template>
